export const FileViewerModal: string = 'FileViewerModal';
